module.exports = __webpack_public_path__ + "static/img/default-work-img.b58a21fd.png";